import { useContent } from "@/lib/ContentContext";

// Ordered platform registry — add a new platform here + its icon to extend.
export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "tiktok", label: "TikTok" },
  { key: "youtube", label: "YouTube" },
  { key: "x", label: "X" },
  { key: "linkedin", label: "LinkedIn" },
];

const ICONS = {
  facebook: (
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.06 5.66 21.2 10.44 22v-7.03H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.9h-2.34V22C18.34 21.2 22 17.06 22 12.06Z" />
  ),
  instagram: (
    <path d="M12 2c2.72 0 3.06.01 4.12.06 1.07.05 1.8.22 2.43.47.66.25 1.22.6 1.77 1.15.55.55.9 1.11 1.15 1.77.25.63.42 1.36.47 2.43.05 1.07.06 1.4.06 4.12s-.01 3.06-.06 4.12c-.05 1.07-.22 1.8-.47 2.43a4.9 4.9 0 0 1-1.15 1.77c-.55.55-1.11.9-1.77 1.15-.63.25-1.36.42-2.43.47-1.07.05-1.4.06-4.12.06s-3.06-.01-4.12-.06c-1.07-.05-1.8-.22-2.43-.47a4.9 4.9 0 0 1-1.77-1.15 4.9 4.9 0 0 1-1.15-1.77c-.25-.63-.42-1.36-.47-2.43C2.01 15.06 2 14.72 2 12s.01-3.06.06-4.12c.05-1.07.22-1.8.47-2.43.25-.66.6-1.22 1.15-1.77.55-.55 1.11-.9 1.77-1.15.63-.25 1.36-.42 2.43-.47C8.94 2.01 9.28 2 12 2Zm0 1.8c-2.67 0-2.99.01-4.04.06-.98.04-1.51.21-1.86.35-.47.18-.8.4-1.15.75-.35.35-.57.68-.75 1.15-.14.35-.31.88-.35 1.86-.05 1.05-.06 1.37-.06 4.04s.01 2.99.06 4.04c.04.98.21 1.51.35 1.86.18.47.4.8.75 1.15.35.35.68.57 1.15.75.35.14.88.31 1.86.35 1.05.05 1.37.06 4.04.06s2.99-.01 4.04-.06c.98-.04 1.51-.21 1.86-.35.47-.18.8-.4 1.15-.75.35-.35.57-.68.75-1.15.14-.35.31-.88.35-1.86.05-1.05.06-1.37.06-4.04s-.01-2.99-.06-4.04c-.04-.98-.21-1.51-.35-1.86a3.1 3.1 0 0 0-.75-1.15 3.1 3.1 0 0 0-1.15-.75c-.35-.14-.88-.31-1.86-.35C14.99 3.81 14.67 3.8 12 3.8Zm0 3.07a5.13 5.13 0 1 1 0 10.26 5.13 5.13 0 0 1 0-10.26Zm0 1.8a3.33 3.33 0 1 0 0 6.66 3.33 3.33 0 0 0 0-6.66Zm5.34-3.2a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z" />
  ),
  tiktok: (
    <path d="M16.5 3c.36 2.02 1.5 3.6 3.5 3.94v2.5c-1.32.04-2.55-.34-3.7-1.03v5.9c0 3.06-2.36 5.19-5.2 5.19A5.17 5.17 0 0 1 5.9 14.3a5.16 5.16 0 0 1 6.1-5.08v2.6a2.6 2.6 0 0 0-1-.2 2.57 2.57 0 1 0 2.58 2.57V3h3.02Z" />
  ),
  youtube: (
    <path d="M23 12s0-3.2-.4-4.74a2.5 2.5 0 0 0-1.76-1.77C19.29 5.1 12 5.1 12 5.1s-7.29 0-8.84.39a2.5 2.5 0 0 0-1.76 1.77C1 8.8 1 12 1 12s0 3.2.4 4.74a2.5 2.5 0 0 0 1.76 1.77c1.55.39 8.84.39 8.84.39s7.29 0 8.84-.39a2.5 2.5 0 0 0 1.76-1.77C23 15.2 23 12 23 12ZM9.75 15.02V8.98L15 12l-5.25 3.02Z" />
  ),
  x: (
    <path d="M17.53 3H21l-7.19 8.21L22.5 21h-6.6l-5.17-6.76L4.8 21H1.33l7.69-8.79L1.5 3h6.77l4.67 6.18L17.53 3Zm-1.16 16h1.83L7.72 4.9H5.76L16.37 19Z" />
  ),
  linkedin: (
    <path d="M4.98 3.5A2.5 2.5 0 1 1 5 8.5a2.5 2.5 0 0 1-.02-5ZM3 9h4v12H3V9Zm6 0h3.84v1.64h.05c.53-1 1.84-2.06 3.79-2.06C20.7 8.58 22 10.3 22 13.4V21h-4v-6.72c0-1.6-.03-3.66-2.23-3.66-2.23 0-2.57 1.74-2.57 3.54V21H9V9Z" />
  ),
};

const track = (key) => { try { if (window.gtag) window.gtag("event", `social_${key}_clicked`); } catch (e) {} };

const normalize = (val) => {
  if (!val) return { url: "", enabled: false };
  if (typeof val === "string") return { url: val, enabled: !!val };
  return { url: val.url || "", enabled: !!val.enabled };
};

const isSafe = (url) => typeof url === "string" && /^https?:\/\//i.test(url);

// Returns the enabled+valid platforms from a content.social_links object.
export const activeSocials = (socialLinks) =>
  SOCIAL_PLATFORMS.map((p) => ({ ...p, ...normalize((socialLinks || {})[p.key]) }))
    .filter((p) => p.enabled && isSafe(p.url));

export const SocialLinks = ({ className = "", iconClass = "w-5 h-5" }) => {
  const { content } = useContent();
  const items = activeSocials(content.social_links);
  if (items.length === 0) return null;
  return (
    <div className={className} data-testid="footer-social">
      <h4 className="overline text-[var(--aqua)] mb-4">Follow Us</h4>
      <div className="flex flex-wrap gap-3">
        {items.map((p) => (
          <a key={p.key} href={p.url} target="_blank" rel="noopener noreferrer"
            aria-label={p.label} title={p.label} onClick={() => track(p.key)}
            data-testid={`social-${p.key}`}
            className="w-10 h-10 rounded-full bg-white/10 hover:bg-[var(--red)] flex items-center justify-center transition-colors">
            <svg viewBox="0 0 24 24" className={`${iconClass} fill-current text-white`} aria-hidden="true">{ICONS[p.key]}</svg>
          </a>
        ))}
      </div>
    </div>
  );
};
